export const CLAIMED = "claimed";
export const NOT_CLAIMED = "not_claimed";
export const NEW = "new";
